var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle17",
    d: "M250 40C134.02 40 40 134.02 40 250C40 365.98 134.02 460 250 460C365.98 460 460 365.98 460 250C460 134.02 365.98 40 250 40ZM250 59.0938L300.688 236.469H300.656C301.942 241.042 302.625 245.858 302.625 250.844C302.625 280.03 279.071 303.688 250 303.688C220.929 303.688 197.375 280.03 197.375 250.844C197.375 245.858 198.058 241.042 199.344 236.469H199.281L250 59.0938ZM250 124.906L216.656 241.562H216.688C215.842 244.57 215.375 247.721 215.375 251C215.375 270.195 230.881 285.75 250 285.75C269.119 285.75 284.625 270.195 284.625 251C284.625 247.721 284.158 244.57 283.312 241.562H283.344L250 124.906Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a6b69d8127cfbb1f86100e51df7846fc.svg";
export { ForwardRef as ReactComponent };